module.exports = __webpack_public_path__ + "img/mono-editar.aa8d6aa0.svg";